import React, { useState } from 'react';
import { Visibility, VisibilityOff, ContentCopy } from '@mui/icons-material';
import { Button, IconButton, Tooltip } from '@mui/material';
import styles from "./IRTable.module.css";

function UserCreationStatus({ response, handleClose, name, username, password, email }) {
  const [showPassword, setShowPassword] = useState(false);
  const [copyStatus, setCopyStatus] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCopyCredentials = () => {
    navigator.clipboard.writeText(`Username: ${username}\nPassword: ${password}\n\nBigCommerce Login Credentials\nEmail:${email}\nNote: IR will get an auto-generated email\nfrom BigCommerce to reset their password.`).then(() => {
      setCopyStatus("Copied!");
      setTimeout(() => setCopyStatus(""), 2000);
    });
  };

  return (
    <div style={{ paddingLeft: "20px", paddingBottom: "20px" }}>
      <ul style={{ listStyleType: "none", padding: 0 }}>
        {response.bttn_ui && response.bigcommerce_flag ? (
          <li style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            { <p>We've successfully created an account for <strong>{name}</strong>.</p> /*You can copy the credentials given below to send them to {email}</p> */}
            <div style={{ marginTop: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <h3 style={{ margin: 0 }}>UI Tool Login Credentials</h3>
                <Tooltip title="Copy to clipboard">
                  <IconButton onClick={handleCopyCredentials} aria-label="copy credentials">
                    <ContentCopy />
                  </IconButton>
                </Tooltip>
              </div>
              <div>
                <p><strong>Username:</strong> {username}</p>
                <p>
                  <strong>Password:</strong> {showPassword ? password : "••••••••"}
                  <IconButton onClick={togglePasswordVisibility} aria-label="toggle password visibility">
                    {showPassword ? <Visibility /> :  <VisibilityOff />}
                  </IconButton>
                </p>
                <div><h3 style={{ margin: 0 }}>BigCommerce Login Credentials</h3></div>
                <p><strong>Email:</strong>{email}</p>
                <p><small>Note: IR will get an auto-generated email <br/> from BigCommerce to reset their password.</small></p>
              </div>
              {copyStatus && <p style={{ color: 'green', marginTop: '10px' }}>{copyStatus}</p>}
            </div>
          </li>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            Sorry, looks like there is a problem creating this IR Account. Please contact the engineering support team for the issue.
          </div>
        )}
      </ul>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "20px" }}>
        <Button variant="contained" style={{ backgroundColor: "#0a2972", color: 'white' }} onClick={handleClose}>
          Close
        </Button>
      </div>
    </div>
  );
}

export default UserCreationStatus;
